import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/database';
import format from 'date-fns/format'
import _ from 'lodash'
export default {
    namespaced: true,
    state: {
      trackOpen:false
    },
    mutations: {
      
      setTrackOpen(state:any, result:any) {
        state.trackOpen = result
      },
    },
    actions: {
       updateOpen({ commit, dispatch, rootState, state }: any, value: any){
        firebase.firestore().collection(`sendemail`).doc(value).get().then(function (doc) {
          if (doc.exists){
            const data = doc.data();
            if(data!==undefined){
              const trackOpen=data.trackOpen
              commit('setTrackOpen', trackOpen)
    
              if(trackOpen==false) firebase.firestore().collection(`sendemail`).doc(value).update({trackOpen:true})
            }
            
        
          } else {
            console.log("No such document!");
          }
         
          
          })
       
      
      }

    },
    getters: {
      trackOpen: (state: any) => {
        return state.trackOpen
      }
    }
  }